import { render } from "./CreateForm.vue?vue&type=template&id=c865a6cc&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=c865a6cc&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=c865a6cc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c865a6cc"]])

export default __exports__